import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getAllCustomers, getSTSToken, getVehicleDetails } from "../services";
import { ACTIONS, DispatchContext, SimulatorContext } from "store/context";
import { Button, Divider, Flex, Input, message, Modal, Tag, Tooltip, Typography } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const Settings = ({ accessKeyId }) => {
  const { Title } = Typography;
  const { vehicleSimulatorSettings } = useContext(SimulatorContext);
  const dispatch = useContext(DispatchContext);
  const [fetchVehicleDetails, setFetchVehicleDetails] = useState(false);
  const [vehicleKey, setVehicleKey] = useState(
    vehicleSimulatorSettings?.vehicleKey || ""
  );
  const [customer, setCustomer] = useState(
    vehicleSimulatorSettings?.customer || ""
  );
  const [serialNo, setSerialNo] = useState(
    vehicleSimulatorSettings?.serialNo || ""
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      type: 'loading',
      content: 'Action in progress..',
      duration: 0,
    });
    // Dismiss manually and asynchronously
    setTimeout(messageApi.destroy, 2500);
  };

  const {
    data: {
      data: { device: { vehicleKey: updatedVehicleKey = "" } = {} } = {},
    } = {},
    isFetched,
    isError,
    isSuccess: vehicleKeySuccess,
    error,
    isFetching,
    isLoading,
  } = useQuery({
    queryKey: ["getVehicleDetails", serialNo],
    queryFn: getVehicleDetails,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: true,
    retry: 1,
    enabled: fetchVehicleDetails,
  });

  const {
    data: { data: customerData = [] } = {},
    isFetched: customerFetched,
    isFetching: isCustomerFetching,
    isLoading: isCustomerLoading,
  } = useQuery({
    queryKey: ["getAllCustomers"],
    queryFn: getAllCustomers,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: true,
    retry: 1,
    enabled: fetchVehicleDetails,
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => setIsModalOpen(false);

  const onSerialNoChange = (e) => {
    if (e.target.value) {
      setSerialNo(e.target.value);
      setFetchVehicleDetails(true);
    } else {
      setVehicleKey("");
    }
  };

  const { data: { data: creds = {} } = {}, isSuccess } = useQuery({
    queryKey: ["getSTSToken"],
    queryFn: getSTSToken,
    refetchOnWindowFocus: false,
    refetchInterval: 300000, // Refresh every 100 seconds if enabled
    refetchIntervalInBackground: true,
    retry: 1,
  });

  useEffect(() => {
    if (isFetched) {
      setFetchVehicleDetails(false);
      setVehicleKey(updatedVehicleKey);
    }
    if (vehicleKeySuccess) {
      messageApi.info('Vehicle Details Fetched!');
    }
    if (isError) {
      setFetchVehicleDetails(false)
      console.log(error)
      messageApi.error(error?.response?.data?.message);
    }
  }, [isFetched, isError, vehicleKeySuccess]);

  useEffect(() => {
    if (isSuccess) {
      dispatch({
        type: ACTIONS.UPDATE_STS_TOKEN,
        payload: creds,
      });
    }
  }, [creds, isSuccess]);

  useEffect(() => {
    if (!customer) {
      showModal()
    } else {
      localStorage.setItem("simulatorCustomer", customer);
      dispatch({
        type: ACTIONS.VEHICLE_SIMULATOR_SETTINGS,
        payload: {
          customer,
        },
      });
    }
    setFetchVehicleDetails(true);
  }, [customer]);

  useEffect(() => {
    if (serialNo !== "" && vehicleKey !== "" && customer !== "") {
      localStorage.setItem("serialNo", serialNo);
      localStorage.setItem("vehicleKey", vehicleKey);
      dispatch({
        type: ACTIONS.VEHICLE_SIMULATOR_SETTINGS,
        payload: {
          serialNo,
          vehicleKey,
          customer,
        },
      });
    }
  }, [serialNo, vehicleKey, customer])

  return (
    <>
      {contextHolder}
      <Tooltip
        title="Vehicle Details are not filled!"
        placement="leftBottom"
        key="volcano"
        color="volcano"
        open={vehicleSimulatorSettings?.serialNo ? false : true}
      >
        <Button
          shape="circle"
          color={vehicleSimulatorSettings?.serialNo ? "primary" : "danger"}
          variant="solid"
          disabled={accessKeyId ? false : true}
          icon={<SettingOutlined />}
          onClick={showModal}
        />
      </Tooltip>
      <Modal
        title="Vehicle Simulator Settings"
        open={isModalOpen}
        footer={(isFetching || isLoading) ? <Tag color="blue">Fetching Vehicle Details...</Tag> : null}
        onOk={() => setIsModalOpen(false)}
        onCancel={handleClose}
        okText={"close"}
        confirmLoading={isFetching || isLoading}
      >

        <Input
          placeholder="Serial No"
          type="text"
          style={{ marginTop: "5%" }}
          onChange={onSerialNoChange}
          value={serialNo}
        />
        <Input
          placeholder="Vehicle Key"
          type="text"
          disabled
          style={{ margin: "5% 0" }}
          value={vehicleKey}
        />

        <Title level={5}>Select Customer</Title>

        <Flex wrap gap="small">
          {customerData.map((c) => <Button
            onClick={() => setCustomer(c?.customerId)} color={c?.customerId === customer ? "green" : "default"}
            variant={c?.customerId === customer ? "solid" : "outlined"} >
            {c?.customerId}
          </Button>)}
        </Flex>
        <Divider />
      </Modal>
    </>
  );
};
export default Settings;
